module.exports = __webpack_public_path__ + "img/race_handUp_icon.37336c88.png";